import axios from "../../config/axiosConfig";
import {
  CREATE_JOB_YARN_ISSUE, DELETE_JOB_YARN_ISSUE,
  GET_JOB_YARN_ISSUE,
  JOB_YARN_ISSUE_REQUEST,
  JOB_YARN_ISSUE_REQUEST_FAILURE,
  UPDATE_JOB_YARN_ISSUE,
  GET_JOB_YARN_ISSUES_PAGE,
  JOB_YARN_ISSUE_REQUEST_SUCCESS,
  GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS,
  JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST,
  JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE
} from "../types/job-yarn-issue-types";


export const getJobYarnIssuesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Job_Id'
      };
      return axios.get("/job-yarn-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_ISSUES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJobYarnIssueById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
    
      return axios.get(`/job-yarn-issue/get/${id}`).then((response) => {
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnIssueBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/job-yarn-issue/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnIssuesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/job-yarn-issue/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJobYarnIssue = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/job-yarn-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_ISSUE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createJobYarnIssue = (jobYarnIssue) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      const newJobYarnIssue = {
        ...jobYarnIssue
      };
      return axios.post("/job-yarn-issue/add", newJobYarnIssue,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_JOB_YARN_ISSUE, payload: response.data });
        } else {
          dispatch({
            type: JOB_YARN_ISSUE_REQUEST_FAILURE,
            error: "Job Yarn Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateJobYarnIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.put("/job-yarn-issue/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_JOB_YARN_ISSUE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: JOB_YARN_ISSUE_REQUEST_FAILURE,
            error: "Job Yarn Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteJobYarnIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_REQUEST });
      return axios.delete(`/job-yarn-issue/delete/${id}`).then((response) => {
        if (response.data) {
          const include = ['id', 'Challan_No', 'P_Challan_No', 'Date', 'Account_Id', 'Job_Id'].join(',');
          const searchCols = ['Challan_No'].join(',');
          const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.jobYarnIssue || {};
          dispatch(getJobYarnIssuesWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
          dispatch({ type: DELETE_JOB_YARN_ISSUE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnIssueAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, customerId: auth?.user?.Customer_Id };
      
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/job-yarn-issue/getAvailableIssues", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};